/** @jsx jsx */ /** @jsxRuntime classic */
import { jsx } from '@emotion/core';
import { memo } from 'react';
import { useI18n } from '../../../i18n';
import DeliveryTruck from '../../../commons/components/icons/DeliveryTruck';
import S from './style/DeliveryBadge';

interface DeliveryBadgeProps {
  large?: boolean;
  desktop?: boolean;
}

function DeliveryBadge({ large, desktop }: DeliveryBadgeProps) {
  const i18n = useI18n();
  let Badge = S.BadgeSmall;
  if (large && desktop) {
    Badge = S.BadgeLargeDesktop;
  } else if (large) {
    Badge = S.BadgeLarge;
  }

  return (
    <Badge>
      <DeliveryTruck css={S.iconStyle} />
      {large && <S.Label>{i18n`dlv_delivery`}</S.Label>}
    </Badge>
  );
}

export default memo(DeliveryBadge);
